import { ButtonPrimary, ButtonSize } from '@ui/src';
import Card from '../card/card';
import TopUpOptionItem from './option-item';
import { TopUpOptionsTypes } from './types';

import cn from './styles.module.css';

const TopUpOptions = ({
  topUpOptions,
  isLoading,
  customerType,
  setSelectedTopUpId,
  setTopUpPanelIsOpen,
  topUpOptionsPagination,
  getNextTopUpOptions,
  topUpOptionsIsLoading,
  status,
  topUpVisibilityIsLoading,
  topUpVisibility,
  activePermissions,
  selectedTopUpOptionId,
  setSelectedTopUpOptionId,
  addTopUpOptionVisibilityIsSuccess,
  updateTopUpOptionVisibilityIsSuccess,
  addVisibilityAction,
  updateVisibiliyAction,
}: TopUpOptionsTypes): React.JSX.Element => (
  <>
    <Card
      isLoading={isLoading}
      title="Top-up options"
      className={
        topUpOptionsPagination?.hasNextPage ? cn.topUpCardSmallMargin : ''
      }
    >
      {topUpOptions?.map((item) => (
        <TopUpOptionItem
          key={item.id}
          topUpOption={item}
          customerType={customerType}
          setTopUpPanelIsOpen={setTopUpPanelIsOpen}
          setSelectedTopUpId={setSelectedTopUpId}
          status={status}
          visibility={topUpVisibility?.find(
            (visibility) => visibility.pspPartnerId === item.id,
          )}
          topUpVisibilityIsLoading={topUpVisibilityIsLoading}
          activePermissions={activePermissions}
          selectedTopUpOptionId={selectedTopUpOptionId}
          setSelectedTopUpOptionId={setSelectedTopUpOptionId}
          addTopUpOptionVisibilityIsSuccess={addTopUpOptionVisibilityIsSuccess}
          updateTopUpOptionVisibilityIsSuccess={
            updateTopUpOptionVisibilityIsSuccess
          }
          addVisibilityAction={addVisibilityAction}
          updateVisibiliyAction={updateVisibiliyAction}
        />
      ))}
    </Card>
    {topUpOptionsPagination?.hasNextPage && (
      <ButtonPrimary
        text={topUpOptionsIsLoading ? 'Loading...' : 'Show more'}
        className={cn.showMoreTopUpButton}
        size={ButtonSize.SMALL}
        onClick={() => getNextTopUpOptions(topUpOptionsPagination.endCursor)}
        bold
      />
    )}
  </>
);

export default TopUpOptions;
